export default (initModule) => {
    let modules = [];

    $('[data-module]').each((index, item) => {
        const module = $(item).data('module');
        const data = $(item).data('data');
        // check for duplicates only initiate one class
        if (!modules.includes(module)) {
            modules.push(module);
            if (typeof initModule[module] !== 'function') {
                return;
            }
            initModule[module](data);
        }
    });
};
